import * as yup from 'yup';

export const validationSchemaArchiveAnnotations = yup.object({
  startDate: yup.date().typeError('Data non valida').nullable(),
  endDate: yup
    .date()
    .typeError('Data non valida')
    .nullable()
    .when('startDate', (startDate, formvalidationSchema) =>
      startDate && startDate?.toString() !== 'Invalid Date'
        ? formvalidationSchema.min(
            startDate,
            'La data deve essere maggiore della data Formazione a'
          )
        : formvalidationSchema.nullable()
    ),
  startDateRegistration: yup.date().typeError('Data non valida').nullable(),
  endDateRegistration: yup
    .date()
    .typeError('Data non valida')
    .nullable()
    .when('startDateRegistration', (startDateRegistration, formvalidationSchema) =>
      startDateRegistration && startDateRegistration?.toString() !== 'Invalid Date'
        ? formvalidationSchema.min(
            startDateRegistration,
            'La data deve essere maggiore della data Registrazione a'
          )
        : formvalidationSchema.nullable()
    ),
});
